import {Hydra} from '../generic/hydra';

import {FinancementRessourcesListInterface} from './FinancementRessourcesList';
import {FinancementRessource as FinancementRessourceBaseInterface} from '../../interface/api/FinancementRessource';

export type FinancementRessourceInterface = FinancementRessourceBaseInterface;

export class FinancementRessource extends Hydra implements FinancementRessourceInterface {

    position?: number | null;

    id?: number | null;

    financementRessourcesList?: FinancementRessourcesListInterface | string | null;

    periode?: string | null;

    organisme?: string | null;

    montantMensuelBrut?: number | null;

    dureeMois?: number | null;


    constructor(options: FinancementRessourceInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
